import { ApolloClient, InMemoryCache } from '@apollo/client'
import staticConfig from 'src/config'
import { networksEnvironments } from 'src/config/networks'
import { createRetryLink, mergeEntities } from './utils'

const defaultNetworkEnv = networksEnvironments[staticConfig.defaultChain.id]

const link = createRetryLink(defaultNetworkEnv.subgraphUrls.sx1155)

const sx1155Client = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          offers: {
            keyArgs: ['id', 'where'],
            merge: mergeEntities,
          },
        },
      },
    },
  }),
})

export default sx1155Client
